import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { sendEvent, sendEventAsync } from '../amplitudeUtil';
import { COUNTRIES } from '../../constants';
import { CORPORATE_CLIENT_ACCOUNT_TYPES } from 'constants/corporateClients.js';

export const getCorporationAccountType = currentCorporation => {
  if (!currentCorporation) return undefined;
  return currentCorporation.isTestCorporation
    ? CORPORATE_CLIENT_ACCOUNT_TYPES.TEST
    : CORPORATE_CLIENT_ACCOUNT_TYPES.STANDARD;
};

// The `company` payload every event carries. Call sites that report on a corporation other than the
// active one (the staff accounts list, the corporation selector) must build their `company` with
// this, so those events are not left with a narrower payload than the rest.
export const getCorporationInfoToLog = corporation => ({
  name: corporation?.corporateClientName,
  id: corporation?.id,
  country: COUNTRIES[corporation?.country]?.label,
  status: corporation?.statusName, //'Active or Deleted or Deactivated or Prospect',
  accountType: getCorporationAccountType(corporation), // test or standard
  registrationType: corporation?.registrationType, // Enterprise or SelfRegistered
  creditAccountStatus: corporation?.creditAccountStatus,
  creditAccountType: corporation?.creditAccountType,
});

const useAmplitude = () => {
  const { currentCorporation } = useSelector(state => state.user);

  const corporationInfoToLog = useMemo(() => getCorporationInfoToLog(currentCorporation), [
    currentCorporation,
  ]);

  const sendAmplitudeEvent = useCallback(
    (eventType, additionalEventProperties = {}) => {
      sendEvent(eventType, {
        company: corporationInfoToLog,
        ...additionalEventProperties,
      });
    },
    [corporationInfoToLog],
  );

  const sendAmplitudeEventAsync = useCallback(
    async (eventType, additionalEventProperties = {}) => {
      await sendEventAsync(eventType, {
        company: corporationInfoToLog,
        ...additionalEventProperties,
      });
    },
    [corporationInfoToLog],
  );

  return {
    sendAmplitudeEvent,
    sendAmplitudeEventAsync,
  };
};

export default useAmplitude;
